import { api } from "./api";

export const apiCustomerPR = {
  getPaymentRequest: (page, size = 10) =>
    api.get("web/customer_payment_request", { page, size }),

  getPaymentRequestDetail: (id) =>
    api.get(`web/customer_payment_request/${id}`),

  getPaymentRequestDetailDriverless: (id) =>
    api.get(`web/customer_payment_request/without_driver/${id}`),

  exportPaymentRequestCustomer: (id) =>
    api.getPdf(`web/export/customer_payment_request/${id}`, {
      fileName: "Payment request",
    }),
};
